export default "__VITE_ASSET__CZxd08Vc__"